import { render } from "./NewsView.vue?vue&type=template&id=3a0cba3d"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"

import "./NewsView.vue?vue&type=style&index=0&id=3a0cba3d&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__